// @flow
import React, { Component } from 'react';
import { TabA } from './TabStyles';
import { MobileHiddenSpan, MobileOnlySpan } from './ResponsiveHelpersStyles';

type Props = {
  activeSection: string,
  sectionName: string,
  mobileSectionName?: string,
  sectionValue: string,
  setActiveSection: (section: string) => void,
  noFlex?: boolean
};

export default class HeaderTab extends Component<Props> {
  handleClick = () => {
    this.props.setActiveSection(this.props.sectionValue);
  };
  render() {
    return (
      <TabA
        onClick={this.handleClick}
        className={
          this.props.activeSection === this.props.sectionValue ? 'active' : ''
        }
        noFlex={this.props.noFlex}
      >
        <MobileHiddenSpan>{this.props.sectionName}</MobileHiddenSpan>
        <MobileOnlySpan>
          {this.props.mobileSectionName || this.props.sectionName}
        </MobileOnlySpan>
      </TabA>
    );
  }
}
